import { Checkbox } from 'core-components/library/checkbox'
import { ICheckboxProps } from 'core-components/library/checkbox/Checkbox'
import { Dropdown, IDropdownProps } from 'core-components/library/dropdown'
import { Static } from 'core-components/types'
import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import { Crud } from 'core/types/Crud'

import { IPartnerShipNA, QualifiedProgramApproval } from '../types'

import styles from './QualifiedProgram.module.scss'

interface IProps {
  item: IPartnerShipNA
  writeAudience: IObjectAny
  onChange: (field: string, isNumber?: boolean) => (value: string) => void
  disabled?: boolean
}

const convertCheckboxValue = (value: boolean): 'true' | 'false' => (value ? 'true' : 'false')

const getCheckboxesFields = () => [
  {
    label: 'Commercial Business Personal Systems (BPS)',
    field: 'QualifiedBPS',
    approvalLabel: 'Approval BPS',
    approvalField: 'ApprovalBPS',
  },
  {
    label: 'Consumer Personal Systems (CPS)',
    field: 'QualifiedCPS',
    approvalLabel: 'Approval CPS',
    approvalField: 'ApprovalCPS',
  },
  {
    label: 'Print Hardware',
    field: 'QualifiedPrintHW',
    approvalLabel: 'Approval Print',
    approvalField: 'ApprovalPrint',
  },
  {
    label: 'Poly',
    field: 'QualifiedPoly',
    approvalLabel: 'Approval Poly',
    approvalField: 'ApprovalPoly',
  },
  {
    label: 'Supplies',
    field: 'QualifiedSupplies',
    approvalLabel: 'Approval Supplies',
    approvalField: 'ApprovalSupplies',
  },
  {
    label: 'Software',
    field: 'QualifiedSoftware',
    approvalLabel: 'Approval Software',
    approvalField: 'ApprovalSoftware',
  },
]

const getApprovalSource = () =>
  new Crud({
    keyField: 'value',
    fetcher: new Static(
      Object.values(QualifiedProgramApproval)
        .filter(Boolean)
        .map((i) => ({ value: i }))
    ),
  })

export const QualifiedProgram = ({ item, writeAudience, onChange, disabled }: IProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Qualified Program</div>
      <div className={styles.text}>
        Partner requested authorization for the below checked categories:
      </div>
      <div className={styles.categories}>
        {getCheckboxesFields().map(({ label, field, approvalLabel, approvalField }) => {
          const isChecked = item[field] === 'true'

          return (
            <div key={field} className={styles.category}>
              <VisualAudienceExtended<ICheckboxProps>
                component={Checkbox}
                write={writeAudience}
                label={label}
                checked={isChecked}
                disabled={disabled}
                onChange={(value) => onChange(field)(convertCheckboxValue(value))}
                inline
              />
              <VisualAudienceExtended<IDropdownProps>
                component={Dropdown}
                write={writeAudience}
                label={approvalLabel}
                caption={'value'}
                source={getApprovalSource()}
                value={item[approvalField] || ''}
                onChange={(value) => onChange(approvalField)(value)}
                classes={{
                  controlClasses: {
                    root: styles.categoryApprovalWrapper,
                  },
                }}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
